import { URLParamStrategy } from "../types";

// Encode search to URL params
export function encodeSearchToURL(
  params: URLSearchParams,
  search: string,
  field: string | undefined,
  strategy: URLParamStrategy
) {
  if (!search?.trim()) {
    // Remove search params if empty
    params.delete("search");
    params.delete("search_field");
    return;
  }

  if (strategy === "prefix") {
    // Format: search=email:john@example.com
    const prefix = field && field !== "all" ? `${field}:` : "";
    params.set("search", `${prefix}${search}`);
  } else {
    // Format: search=john&search_field=email
    params.set("search", search);
    if (field && field !== "all") {
      params.set("search_field", field);
    } else {
      params.delete("search_field");
    }
  }
}

// Decode search from URL params
export function decodeSearchFromURL(
  params: URLSearchParams,
  strategy: URLParamStrategy
): { search: string; field: string } {
  const searchParam = params.get("search");
  
  if (!searchParam) {
    return { search: "", field: "all" };
  }

  if (strategy === "prefix") {
    // Parse format: email:john@example.com
    const colonIndex = searchParam.indexOf(":");
    if (colonIndex > 0) {
      return {
        field: searchParam.substring(0, colonIndex),
        search: searchParam.substring(colonIndex + 1)
      };
    }
    return { search: searchParam, field: "all" };
  } else {
    // Parse format: search=john&search_field=email
    return {
      search: searchParam,
      field: params.get("search_field") || "all"
    };
  }
}

